export default "__VITE_ASSET__BO9Cm52t__"